import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Project } from '../Project'

@InputType()
export class ComputeTotalTimeSpentArgs extends ActionArgs {
  @Field(() => String)
  projectId: string
}

export interface IComputeTotalTimeSpent extends IAction<Project, ComputeTotalTimeSpentArgs> {}
